<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">
      <b-form @submit="onSubmit">
        <b-form-group :label="$t('tuevs.complement.form.fields.codigo.label')" label-for="input-codigo">
          <b-form-input id="input-codigo" v-model="complement.code" type="text"/>
        </b-form-group>
        <b-form-group :label="$t('tuevs.complement.form.fields.nome.label')" label-for="input-name">
          <b-form-input id="input-name" v-model="complement.name" type="text"/>
        </b-form-group>
        <b-form-group
            :label="$t('tuevs.exams.form.fields.material.label')"
            label-for="input-material">
          <b-overlay :show="materialsLoading">
            <SelectComponent
                id="input-material"
                multiple
                :model="complement.specimens"
                :options="materials | idNameToValueLabel"
                @search="evt => {autocomplete('tuevs/material', evt)}"
                @input="evt => setExam('specimens', evt)"
            />
          </b-overlay>
        </b-form-group>

        <b-form-group
            :label="$t('tuevs.complement.form.fields.status.label')"
            label-for="input-status"
            :description="$t('tuevs.complement.form.fields.status.description')"
        >
          <b-form-checkbox id="input-status" v-model="complement.status" size="lg" switch/>
        </b-form-group>
        <b-button type="submit" variant="success">
          <i class="fas fa-save"/> {{ $t('tuevs.complement.form.fields.botao_salvar') }}
        </b-button>
      </b-form>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import ComplementRepository from '@/repositories/tuevs/ComplementRepository'
import SelectComponent from "@/components/SelectComponent";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Form",
  components: {
    LayoutGradient,
    SelectComponent,
  },
  data() {
    return {
      complement_id: null
    }
  },
  computed: {
    ...mapGetters({
      complement: 'tuevs/complement/current',
      isLoading: 'tuevs/complement/isLoading',
      materials: 'tuevs/material/allData',
      materialsLoading: 'tuevs/material/isLoading',
    }),
    pageTitle() {
      if (this.complement_id) return this.$t('tuevs.complement.form.titulo_pagina.editar')
      return this.$t('tuevs.complement.form.titulo_pagina.criar')
    },
    setComplement() {
      return {
        ...this.complement,
        tuevs_specimen_ids: (this.complement.specimens || []).map(specimen => specimen.value)
      }
    },
  },
  async mounted() {
    this.$store.commit('tuevs/complement/setCurrent', {status: false})
    await this['tuevs/material/listAllItems']()
    if (this.$route.params.id) {     
      this.complement_id = this.$route.params.id
      await this['tuevs/complement/listOne'](this.$route.params.id)

      let complement = this.complement

      if (complement.specimens && complement.specimens.length) {
        const currentIds = complement.specimens.map(specimen => specimen.id)
        this.$store.commit('tuevs/material/setAll', [
          ...complement.specimens,
          ...this.materials.filter(obj => !currentIds.includes(obj.id))
        ])
        complement.specimens = complement.specimens.map(specimen => ({label: specimen.name, value: specimen.id}))
      }
    }
  },
  methods: {
    ...mapActions([
      'tuevs/complement/listOne',
      'tuevs/material/search',
      'tuevs/material/listAllItems'
    ]),
    async autocomplete(entityString, string) {
      if (string && string.length >= 3) {
        await this[entityString + '/search']({filters: [['name', 'LIKE', '%' + string + '%']]})
      }
    },
    setExam(key, value) {
      this.$store.commit('tuevs/complement/setCurrent', {...this.complement, [key]: value})
    },
    async onSubmit(evt) {
      evt.preventDefault()
      if (this.$route.params.id) {
        this.update()
      } else {
        this.create()
      }
    },
    create() {
      ComplementRepository.post(this.setComplement).then(() => {
        this.$snotify.success(this.$t('tuevs.complement.form.create.success'))
        this.$router.push({name: 'tuevs.complements'})
      }).catch(error => {
        this.$snotify.error(this.$t('tuevs.complement.form.create.error'))
        if (error.response.status === 422) {
          ComplementRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      ComplementRepository.put(this.complement_id, this.setComplement).then(() => {
        this.$snotify.success(this.$t('tuevs.complement.form.update.success'))
        this.$router.push({name: 'tuevs.complements'})
      }).catch(error => {
        this.$snotify.error(this.$t('tuevs.complement.form.update.error'))
        if (error.response.status === 422) {
          ComplementRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
